import script from "./AboutRaaiSubpage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutRaaiSubpage.vue?vue&type=script&setup=true&lang=js"

import "./AboutRaaiSubpage.vue?vue&type=style&index=0&id=d17a723a&lang=scss"

const __exports__ = script;

export default __exports__